export enum GroupedTalentDictionaryKey {
  RECENTLY_ACTIVE = 'recently-active',
  RECENTLY_JOINED = 'recently-joined',
  RECENTLY_REJECTED = 'recently-rejected',
  SAVED_TALENTS = 'saved-talents',
}
